module.exports = __webpack_public_path__ + "static/media/mail_icon.9f35dfcb.svg";